import { HttpParams } from '@angular/common/http';

export function generateHttpParams(paramObject: { [key: string]: any }): HttpParams {
    let params = new HttpParams();

    Object.keys(paramObject).forEach((key: string) => {
        const value = paramObject[key];
        const hasValue = value !== undefined && value !== null;

        if (Array.isArray(value)) {
            value.forEach((arrayElement: any) => {
                const hasArrayElementValue = arrayElement !== undefined && arrayElement !== null;

                if (hasArrayElementValue) {
                    params = params.append(key, arrayElement);
                }
            });
        } else if (hasValue) {
            params = params.set(key, paramObject[key]);
        }
    });

    return params;
}
